/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */

import Link from "next/link";
import LogoSvg from "@/app/components/assets/common/LogoSvg";

export const Logo = () => {
    const imgWidth = 321;
    const imgHeight = 50;

    return (
        <Link href="/" prefetch={false} className="header-logo" title="Header logo">
            <LogoSvg width={imgWidth} height={imgHeight}/>
        </Link>
    )
}